import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import AdminLayout from "@/components/AdminLayout";
import { Loading } from "@/components/common";

import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Brands from "@/pages/Brands";
import Products from "@/pages/Products";
import QRCodes from "@/pages/QRCodes";
import Customers from "@/pages/Customers";
import WhatsApp from "@/pages/WhatsApp";
import Schemes from "@/pages/Schemes";
import Games from "@/pages/Games";
import Feedback from "@/pages/Feedback";
import Campaigns from "@/pages/Campaigns";
import Redemptions from "@/pages/Redemptions";
import Reports from "@/pages/Reports";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Simulator from "@/pages/Simulator";

function Protected({ children }) {
  const { user } = useApp();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/app/overview" element={<Protected><Overview /></Protected>} />
            <Route path="/app/brands" element={<Protected><Brands /></Protected>} />
            <Route path="/app/products" element={<Protected><Products /></Protected>} />
            <Route path="/app/qr" element={<Protected><QRCodes /></Protected>} />
            <Route path="/app/customers" element={<Protected><Customers /></Protected>} />
            <Route path="/app/whatsapp" element={<Protected><WhatsApp /></Protected>} />
            <Route path="/app/schemes" element={<Protected><Schemes /></Protected>} />
            <Route path="/app/games" element={<Protected><Games /></Protected>} />
            <Route path="/app/feedback" element={<Protected><Feedback /></Protected>} />
            <Route path="/app/campaigns" element={<Protected><Campaigns /></Protected>} />
            <Route path="/app/redemptions" element={<Protected><Redemptions /></Protected>} />
            <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/app/team" element={<Protected><Team /></Protected>} />
            <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/app/overview" replace />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
